import { createAction, props } from "@ngrx/store";
import { Controller, Motor, PumpEnd } from "./controller.reducer";

export const setControlllerName = createAction(
  '[Pump System Form] Set Controlller Name',
  props<{ data: Controller }>()
);

export const setPumpEndName = createAction(
  '[Pump System Form] Set Pump End Name',
  props<{ data: PumpEnd }>()
);

export const setMotorName = createAction(
  '[Pump System Form] Set Motor Name',
  props<{ data: Motor }>()
);

export const setPartsListName = createAction(
  '[Pump System Form] Set Parts List Name',
  props<{ data: String }>()
);
